export default {"src":"/_next/static/media/1-Inkasso.d72fe838.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};